import api from '../..'
import { IQuestionLikertModel } from 'models/questionLikert.model'
import { IOpenEndedModel } from 'models/questionOpenEnded.model'
import { BlockTypes } from 'enum/block-type.enum'

export const createLikertQuestion = (
  data: IQuestionLikertModel<
    BlockTypes.BlockSurvey | BlockTypes.BlockEvaluation
  >
) => {
  return api.post('administration/questions/likerts', data)
}
export const createOpenEndedQuestion = (data: IOpenEndedModel) => {
  return api.post('administration/questions/open_endeds', data)
}
